import React from 'react';
import SpinningSankalvaXLogo from './SpinningSankalvaXLogo';
import { isSankalvaX } from '../../config/branding';

const SpinningGruveLogo = ({ size = 'w-4 h-4', className = '', showBackground = false }) => {
  // Only show SankalvaX spinning logo when on platform.sankalvax.ai
  if (isSankalvaX()) {
    return <SpinningSankalvaXLogo size={size} className={className} showBackground={showBackground} />;
  }

  // Default: Gruve spinning logo (current behavior)
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${size} animate-spin ${className}`}
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Gruve Logo - Rounded square with chain link symbol */}
      {/* Background rounded rectangle */}
      <rect
        x="5"
        y="5"
        width="90"
        height="90"
        rx="18"
        ry="18"
        fill={showBackground ? "#4CAF50" : "currentColor"}
      />

      {/* Chain link / infinity symbol - white paths */}
      <g fill={showBackground ? "#ffffff" : "#ffffff"} stroke="none">
        {/* Left loop of the chain */}
        <path
          d="M25 50
             C25 38, 35 28, 47 28
             C52 28, 56 30, 59 33
             L53 39
             C51 37, 49 36, 47 36
             C40 36, 33 42, 33 50
             C33 58, 40 64, 47 64
             C49 64, 51 63, 53 61
             L59 67
             C56 70, 52 72, 47 72
             C35 72, 25 62, 25 50Z"
          fill={showBackground ? "#ffffff" : "currentColor"}
          opacity={showBackground ? "1" : "0.3"}
        />

        {/* Right loop of the chain */}
        <path
          d="M75 50
             C75 62, 65 72, 53 72
             C48 72, 44 70, 41 67
             L47 61
             C49 63, 51 64, 53 64
             C60 64, 67 58, 67 50
             C67 42, 60 36, 53 36
             C51 36, 49 37, 47 39
             L41 33
             C44 30, 48 28, 53 28
             C65 28, 75 38, 75 50Z"
          fill={showBackground ? "#ffffff" : "currentColor"}
          opacity={showBackground ? "1" : "0.3"}
        />

        {/* Center connecting diagonal */}
        <path
          d="M44 56 L56 44 L60 48 L48 60 Z"
          fill={showBackground ? "#ffffff" : "currentColor"}
          opacity={showBackground ? "1" : "0.3"}
        />
      </g>
    </svg>
  );
};

export default SpinningGruveLogo;
